import React from 'react';
import img1 from '../../../assets/d1.png';
import img2 from '../../../assets/d2.png';
import img3 from '../../../assets/p4.png';
import img4 from '../../../assets/t4.png';
import { FaGithub } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFile } from "react-icons/fa";
const SinglePage2 = () => {
    return (
        <div>
            
        <div class="md:flex items-start justify-center py-12 2xl:px-20 md:px-6 px-4 pt-24">
            <div class="xl:w-2/6 lg:w-2/5 w-full lg:w-80 md:block">
                <img class="w-full" alt="image of a girl posing" src={img1} />
                <img class="mt-6 w-full" alt="image of a girl posing" src={img2} />
                <img class="mt-6 w-full" alt="image of a girl posing" src={img3} />
            </div> 
           
            <div class="xl:w-2/5 md:w-1/2 lg:ml-8 md:ml-6 md:mt-0 mt-6">
                
                <h2 className='text-7xl font-bold'>Daily-Life</h2>
                <div>
                    <p class=" text-base lg:leading-tight leading-normal text-gray-600 dark:text-gray-300 mt-7">Daily-life is a activity web app. See what you are doing in every day and calculate it very easily.Experience a unique and elegant theme that reflects the creativity in a different style.Easily Customizeable</p>
                    <p class=" text-base lg:leading-tight leading-normal text-gray-600 dark:text-gray-300 mt-7">
                    Designed with eye-catching graphics and lots of amazing features, this is just irresistible. Get it now and create a buzz before you launch your website.</p>
                    <h4 className='text-4xl font-semibold mt-10 mb-4'>Features:</h4>
                    <ul className='text-gray-600'>
                        <li>1.Responsive Unique Layout</li>
                        <li>2.Has Calculating System </li>
                        <li>3.Used Tailwind Css for creating this beautiful website</li>
                        <li>4.Used toaster to notify.</li>
                        <li>5.Can see one's activity time and calculate it</li>
                    </ul>
                    <p class="text-base leading-4 mt-7 text-gray-600 dark:text-gray-300">Live Link: <a href="https://daily-life-activity-97.netlify.app/" target="_blank" className='text-orange-600'>https://daily-life-activity-97.netlify.app/</a></p>
                    <p class="text-base leading-4 mt-7 text-gray-600 dark:text-gray-300">GitHub Code Link: <a href="https://github.com/devmonika/Activitys-React" className='text-orange-600' target="_blank">https://github.com/devmonika/Activitys-React</a></p>
                </div>
                <div>
                    <div class="border-t border-b py-4 mt-7 border-gray-200">
                        <div data-menu class="flex justify-between items-center cursor-pointer">
                            <div className='text-gray-600 flex'>
                            <a className='text-3xl text-orange-600' href='https://github.com/devmonika'><FaGithub></FaGithub></a>
                            <a className='text-3xl text-orange-600 px-5' href='https://www.linkedin.com/in/monika-hossan-momi/'><FaLinkedinIn></FaLinkedinIn></a>
                            <a className='text-3xl text-orange-600' href='Resume.pdf' download><FaFile></FaFile></a>
                            </div>
                            
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
      
      
    
        </div>
    );
};

export default SinglePage2;